import type { FC } from 'react'

import { Tag } from '@/components/ui/tag'
import { Tooltip } from '@/components/ui/tooltip'
import { classNames } from '@/utils/helpers'

import { unescapeHtmlText } from '../chat-window/fan-info/utils'

interface Props {
  item: {
    name: string
    id: string
    badge?: string | number
    tooltip?: string
  }
  isDisabled?: boolean
  isSelected?: boolean
  onClick: () => void
  tagClassName?: string
}

export const TagListItem: FC<Props> = ({
  item,
  isDisabled,
  isSelected,
  onClick,
  tagClassName,
}) => {
  const { name, badge, tooltip } = item

  const content = (
    <>
      <Tag
        aria-selected={isSelected}
        onClick={isDisabled ? undefined : onClick}
        className={classNames(
          'bg-secondary-50 dark:bg-secondary-600 cursor-pointer hover:bg-teal-500/10 aria-selected:bg-teal-500/10 hover:dark:bg-teal-500/30 aria-selected:dark:bg-teal-500/30',
          isDisabled && 'pointer-events-none cursor-default opacity-50',
          tagClassName,
        )}
      >
        {unescapeHtmlText(name)}
      </Tag>
      {Boolean(badge) && (
        <div className="bg-danger-default absolute -right-0.5 -top-1 flex h-4 w-4 items-center justify-center rounded-full text-xs text-white pointer-events-none">
          {badge}
        </div>
      )}
    </>
  )

  if (tooltip) {
    return (
      <div className="relative shrink-0">
        <Tooltip content={tooltip}>{content}</Tooltip>
      </div>
    )
  }

  return <div className="relative shrink-0">{content}</div>
}
